import { Card } from '@components/common/Cards/Card';

export const CardJobTalentSkeleton = () => (
  <Card className="flex animate-pulse flex-col justify-between overflow-hidden rounded-md bg-surface px-3 py-5">
    <div className="grid grid-cols-10">
      <div className="col-span-7">
        <div className="h-5 w-32 rounded-md bg-surface-200" />
        <div className="mt-4 h-3 w-24 rounded-md bg-surface-200" />
        <div className="mt-4 h-3 w-24 rounded-md bg-surface-200" />
      </div>
      <div className="col-span-3 flex flex-col items-center">
        <div className="size-15 rounded-md bg-surface-200" />
        <div className="mt-3 h-3 w-20 rounded-md bg-surface-200" />
      </div>
    </div>
    <div className="mt-8">
      <div className="h-3 w-24 rounded-md bg-surface-200" />
      <div className="mt-2 h-3 w-24 rounded-md bg-surface-200" />
    </div>
  </Card>
);
